import { useViewportSize } from '@mantine/hooks'
import { AffiliateBanner, DiscountText, Colored, RedChibi, redChibi } from './styles/LandingPageBanner.styles'

import useMobile from 'src/hooks/useMobile'

const LandingPageBanner = ({ affiliate, scrollToPlanSelect }) => {
  if (!affiliate) return <></>
  
  const { identifier } = affiliate
  const { width } = useViewportSize()
  const showFullText = width > 960
  const showChibi = width > 690
  const breakText = width < 450

  return (
    <AffiliateBanner onClick={scrollToPlanSelect}>
      {showChibi && <RedChibi src={redChibi} alt='Tomoko smiling and waving' />}
      <DiscountText>
        {showFullText && 'You\'ve unlocked '}50% OFF{breakText ? <br/> : ' '}{!showFullText && ' unlocked '}with{' '}
        <Colored>{identifier}{showFullText ? "'s" : ''}</Colored>
        {showFullText && ' discount'}!
      </DiscountText>
    </AffiliateBanner>
  )
}

export default LandingPageBanner
